export default "__VITE_ASSET__DEnT$DVb__"